import React, { Component } from 'react'

class SelectorInput extends Component {
    render() {
        const { value, onClick, onReset, disabled = false } = this.props
        return (
            <div className="form-control input-sm SelectorInput" zindex={ 2000 } disabled={ disabled }>
                <span className="caption">
                    <span>
                        { value }
                    </span>
                </span>
                { value ? <span className="reset" onClick={ (e) => onReset(e) }>&#10005;</span> : null }
                <span className="button">
                    <button onClick={ (e) => { e.preventDefault(); onClick(e) }} disabled={ disabled }>...</button>
                </span>
            </div>
        )
    }
}

export default SelectorInput


// WEBPACK FOOTER //
// ./src/components/Shared/SelectorInput.jsx